<div class="normal-modal-component">
  <div class="close-btn" *ngIf="!hideCancelButton">
    <mat-icon (click)="close()" svgIcon="close"></mat-icon>
  </div>
  <div mat-dialog-title>{{ title }}</div>
  <div mat-dialog-content style="overflow-y: auto">
    <div [innerHtml]="content"></div>
  </div>
  <div mat-dialog-actions>
    <span class="cancel" (click)="close()" *ngIf="!hideCancelButton">{{cancelText}}</span>
    <button mat-raised-button color="primary02" class="sm" (click)="confirm()">{{confirmText}}</button>
  </div>
</div>
